import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger );

const fruits = Array.from( document.querySelectorAll( '.u-parallaxFruit' ) );

if ( fruits.length ) {
	fruits.forEach( ( el ) => {
		const speedAttr = el.getAttribute( 'data-speed' );
		const speed = speedAttr ? parseFloat( speedAttr ) : 0.4;
		// Compute distance relative to viewport for stronger effect
		const computeDistance = () => {
			const vh = window.innerHeight || 800;
			// Base travel is 60% of viewport height, scaled by speed; min 240px
			const base = Math.max( vh * 0.6, 240 );
			return base * speed;
		};
		// Use data-direction to determine movement (up|down)
		const dirAttr = el.getAttribute( 'data-direction' );
		const moveDown = dirAttr === 'down';

		gsap.fromTo(
			el,
			{ y: 0 },
			{
				y: () => ( moveDown ? computeDistance() : -computeDistance() ),
				ease: 'none',
				scrollTrigger: {
					trigger: el,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
					invalidateOnRefresh: true,
				},
				force3D: true,
			}
		);
	} );
}